// NOTE: the order of the metrics is important
const metricTypes = {
  BOOKED_NIGHTS: 'BOOKED_NIGHTS',
  OCCUPANCY: 'OCCUPANCY',
  ACCOMMODATION_FARE: 'ACCOMMODATION_FARE',
  NET_RENTAL_INCOME: 'NET_RENTAL_INCOME',
  AVG_NIGHTLY_RATE: 'AVG_NIGHTLY_RATE',
  REV_PAL: 'REV_PAL',
  OWNER_REVENUE: 'OWNER_REVENUE',
};

export default metricTypes;
